// Override Settings
var bcSfFilterSettings = {
    general: {
      	limit: (bcSfFilterConfig.custom.collection_tile_image) ? bcSfFilterConfig.custom.products_per_page - 1 : bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
        styleScrollToTop: 'style2',
      	extraSortingList: 'extra-sort1-descending',
    }
};

var bcSfFilterTemplate = {
    'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',
    'onSaleClass': 'on-sale',

    // Grid Template
    'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
    'soldOutLabelGridHtml': '',
    'productGridItemHtml': '<div class="grid__item item-product {{itemGridWidthClass}}" data-bc-preorder="{{itemPreorder}}">' + 
                                '<div class="bc-quickview-btn-wrapper" data-bc-qv-template="{{itemUrl}}?view=bc-quickview"><span class="bc-quickview-btn"><span><i class="fa fa-eye"></i></span></span></div>' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="grid-view-item {{soldOutClass}}">' + 
                                	'<div class="bs-sf-filter-badges">{{itemBadges}}</div>'+
                                    '<a class="grid-view-item__link" href="{{itemUrl}}">' +
  										'<div class="reveal">'+
                                        '<img class="grid-view-item__image imagethumb1" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        ' <!--img class="grid-view-item__image imagethumb2" src="{{itemThumbUrl2}}" -->  ' +
  										'</div>'+
                                        '<div class="grid-view-item__meta">{{itemPrice}}{{itemSoldOutLabel}}</div>' +
                                        '<div class="h4 grid-view-item__title">{{itemTitle}} </div>' +
                                        '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                                         '{{itemVendor}}' +
                                         
                                    '</a>' +
                                '</div>' +
  								'<div class="homepage-three-blogs-target"></div>'+
  								'{{itemWishListScript}}' +
                            '</div>',

  	'productTiteItemHtml': '<div class="grid__item item-product product-tite {{itemGridWidthClass}}" data-bc-preorder="{{itemPreorder}}">' + 
                                '<div class="background-image grid-view-item " style="background-image: url(\'{{itemThumbUrl}}\');">' +
  									'<div class="info">' +
                                        '<div class="heading h3">{{itemTitle}}</div>' +
                                        '<div class="description">{{itemDescription}}</div>' +
  										'<div class="view_more"></div>' +
                                        '<div class="video" data-template="/collection/' + bcSfFilterMainConfig.general.collection_handle + '" data-href="{{itemVideo}}"></div>' +
  									'</div>' +
                                '</div>' +
                            '</div>',

    // List Template
    'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
    'vendorMediumListHtml': '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
    'saleLabelListHtml': '<div class="list-view-item__on-sale">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + bcSfFilterConfig.label.sold_out + '</div>',
    'productListItemHtml':  '<a href="{{itemUrl}}" class="list-view-item">' +
                                '<div class="list-view-item__image-column">' +
                                    '<div class="list-view-item__image-wrapper">' +
                                        '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                    '</div>' +
                                '</div>' +
                                '<div class="list-view-item__title-column">' +
                                    '<div class="list-view-item__title">{{itemTitle}}</div>' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemMediumVendor}}' +
                                    '{{itemSoldOutLabel}}' +
                                '</div>' +
                                '{{itemSmallVendor}}' +
                                '<div class="list-view-item__price-column">{{itemPrice}}</div>' +
                            '</a>',

                            
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><i class="fa fa-angle-left"></i><span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><i class="fa fa-angle-left"></i><span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><i class="fa fa-angle-right"></i><span class="icon__fallback-text">Next</span></a></li>',
    'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><i class="fa fa-angle-right"></i><span class="icon__fallback-text">Next</span></div></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}',


    // Sorting Template
  	'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select value=" " class="product-single__variants selector-wrapper js product-form__item product-size-option1 tiendz filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};




BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = '';
  if (index == 1) {
    itemHtml += buildCollectionTite(data);
  }
  itemHtml += bcSfFilterTemplate.productGridItemHtml;

  // Add a specific class for grid item
  var itemGridWidthClass = '';
  var imageSize = '600x600';
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      itemGridWidthClass = 'medium-up--one-half';
      imageSize = '540x600';
      break;
    case 3:
      itemGridWidthClass = 'small--one-half medium-up--one-third';
      imageSize = '345x550';
      break;
    case 4:
      itemGridWidthClass = 'small--one-half medium-up--one-quarter';
      imageSize = '250x';
      break;
    case 5:
      itemGridWidthClass = 'small--one-half medium-up--one-fifth';
      imageSize = '195x';
      break;
  }
  itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
  itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

  // Add soldOut item
  var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

  // Add Thumbnail
  if (images.length > 1) {
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '300x300') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    var itemThumbUrl2 = images.length > 1 ? this.optimizeImage(images[1]['src'], '300x300') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl2}}/g, itemThumbUrl2);
  } else {
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '300x300') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    var itemThumbUrl2 = images.length > 0 ? this.optimizeImage(images[0]['src'], '300x300') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl2}}/g, itemThumbUrl2);
  }


  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add Price
  var itemPriceHtml = '';
  if (onSale) {
    if (priceVaries) {
      itemPriceHtml += '<div class="product-detail on-sale"><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
      itemPriceHtml += ' <span class="product-price__price product-price__sale">';
      itemPriceHtml += '<span class="product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';

      itemPriceHtml += '</span> </div>';
      //itemPriceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
    } else {
      itemPriceHtml += '<div class="product-detail on-sale"><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<s class="product-price__sale">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span></s>';
      itemPriceHtml += ' <span class="product-price__price ">';
      itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);

      itemPriceHtml += '</span> </div>';
      //itemPriceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
    }
  } else {
    if (priceVaries) {
      itemPriceHtml += '<span class="product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    } else {
      itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  

  // Add data json
  var self = this;
  var preorder = data.metafields.filter(item => item.key == "Preorder Date" && item.namespace == "global").length > 0? true: false;
  var url_get = self.buildProductItemUrl(data);
  url_get = url_get.split("/");
  
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "tag": data.tags,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": "/" + url_get[3] + "/" + url_get[4] + "/",
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max,
    "preorder": preorder
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));
  
  //{{itemBadges}}
  itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildItemBadges(data));
  
  var itemWishlistHtml = '<script class="swym-product-view-snippet">';
  itemWishlistHtml += 'if(!window.SwymViewProducts){'
  itemWishlistHtml += 'window.SwymViewProducts = {};'
  itemWishlistHtml += '}';
  itemWishlistHtml += 'if(!window.SwymWatchProducts){';
  itemWishlistHtml += 'window.SwymWatchProducts = {};';
  itemWishlistHtml += '}';
  itemWishlistHtml += '(function(et){';
  itemWishlistHtml += 'var collections = ' + JSON.stringify(data.collections[0].title) + ';';
  itemWishlistHtml += 'var variants = [], currentVariant, variantPrice = ' + (data.price_min / 100) + ', stk;';
  itemWishlistHtml += 'if (variants.length == 0){';
  itemWishlistHtml += 'currentVariant = ' + JSON.stringify(firstVariant.id) + ';variants.push({ ' + JSON.stringify(firstVariant.title) + ' :' + JSON.stringify(firstVariant.id) + '});variantPrice = ' + (firstVariant.price / 100) + ';';

  itemWishlistHtml += 'stk = ' + firstVariant.inventory_quantity + ';';
  itemWishlistHtml += '}';
  itemWishlistHtml += 'var product_data = {';
  itemWishlistHtml += 'empi:' + JSON.stringify(data.id) + ',epi : currentVariant,';
  itemWishlistHtml += 'dt :' + JSON.stringify(data.title) + ',du  :"' + bcSfFilterConfig.shop.url + '{{itemUrl}}",';
  itemWishlistHtml += 'ct     :collections,pr     : variantPrice, stk: stk,';
  itemWishlistHtml += 'iu :' + JSON.stringify(this.getFeaturedImage(images)) + ',variants:variants';
  itemWishlistHtml += '};';
  itemWishlistHtml += 'SwymViewProducts[' + JSON.stringify(data.handle) + '] = SwymViewProducts[' + JSON.stringify(data.id) + '] = product_data;';
  itemWishlistHtml += 'var o = {};';

  for (var k in data.variants) {
    var variant = data['variants'][k]
    itemWishlistHtml += 'o[' + JSON.stringify(variant.id) + '] = {"id": ' + JSON.stringify(variant.id) + ',"inventory_management": ' + JSON.stringify(variant.inventory_management) + ',"inventory_quantity": ' + JSON.stringify(variant.inventory_quantity) + ',"title": ' + JSON.stringify(variant.title) + ', "inventory_policy": ' + JSON.stringify(variant.inventory_policy) + '};';
  }

  itemWishlistHtml += 'SwymWatchProducts[' + JSON.stringify(data.handle) + '] = SwymWatchProducts[' + JSON.stringify(data.id) + '] = o;';
  itemWishlistHtml += '})();';
  itemWishlistHtml += '</script>';  
  
  itemHtml = itemHtml.replace(/{{itemWishListScript}}/g, itemWishlistHtml);
  
  var url_get = this.buildProductItemUrl(data);
  url_get = url_get.split("/");

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemtag}}/g, data.tags);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/" + url_get[3] + "/" + url_get[4] + "/");
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  return itemHtml;
}

BCSfFilter.prototype.buildProductListItem = function(data) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Add onSale item
  var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

  // Add soldOut item
  var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Vendor
  var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorSmallListHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
  var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

  // Add Price
  var itemPriceHtml = '';
  if (onSale) {
    if (priceVaries) {
      itemPriceHtml += '<div class="product-detail on-sale"><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
      itemPriceHtml += '<span class=" product-price__sale">';
      itemPriceHtml += '<span class="product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';

      itemPriceHtml += '</span></div>';
      //itemPriceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
    } else {
      itemPriceHtml += '<div class="product-detail on-sale"><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
      itemPriceHtml += '<span class="product-price__price product-price__sale">';
      itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat) + '</span>';

      itemPriceHtml += '</span></div>';
      //itemPriceHtml += ' <span class="product-price__sale-label">' + bcSfFilterConfig.label.sale + '</span>';
    }
  } else {
    if (priceVaries) {
      itemPriceHtml += '<span class="product__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    } else {
      itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  
  var url_get = this.buildProductItemUrl(data);
  url_get = url_get.split("/");


  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/" + url_get[3] + "/" + url_get[4] + "/");

  return itemHtml;
}

/* Start BC-21243 */
function buildItemBadges(data){
  var html = '';
  var iconUrl = $('.shippingIcon').attr('src');
  var _label;
  var stickers = [];

  // if(data.tags.indexOf('free_shipping') >= 0) {
  //   _label = bcsffilter.getLabel('label', 'badge_free_ship', 'Free Shipping'),
  //   html += '<span class="badge-label badge-ships-today">' + '<div class="badge-ships-today-inner"><img src="' + iconUrl + '" alt="free-shipping-icon">' + _label +'</div></span>';
  // }
  
  if(data.compare_at_price_min > data.price_min) {
    html += ' <span class="badge-label badge-sale">' + bcSfFilterConfig.label.sale + '</span>';
    var sticker = '<span class="badge-label badge-sale">' + bcSfFilterConfig.label.sale + '</span>';
    stickers.push(sticker);
  }

  if(data.available){
    
    var inventory = 0;

    

    jQ.each(data.variants, function(i, variant){
      inventory += variant.inventory_quantity;
    });

    // if(inventory > 1 && data.tags.indexOf('bulky') === -1) {
    //   _label = bcsffilter.getLabel('label', 'badge_ships_today', 'Ships Today');
    //   html += '<span class="badge-label badge-ships-today">' + '<div class="badge-ships-today-inner"><img src="' + iconUrl + '" alt="free-shipping-icon">' + _label +'</div></span>';
    // }

    // _label = bcsffilter.getLabel('label', 'badge_in_stock', 'In Stock');
    // html += '<span class="badge-label badge-in-stock">'+ _label +'</span>';
    
    if(inventory <= 0) {
      
    }
  }
  //custom tagged labels
    const labels = data.tags.filter(function(tag) { return tag.indexOf('label:') > -1; });
      
    labels.forEach(function(tag) {
    var label = tag.split(':')[1].toLowerCase().trim();
    var labelClass = label.replace(' ', '-');
    //<img src="' + iconUrl + '" alt="free-shipping-icon">
    var sticker = '<div class="' + labelClass +  '-sticker thumbnail-sticker"><span class="sticker-text">' + label + '</span></div>';
    
    stickers.push(sticker);
    });

    if (stickers.length > 0){
			html = '<div class="sticker-holder">' +
							stickers.join('') +
					'</div>';
    }
  
  return html;
}
/* End BC-21243 */

function buildCollectionTite(data) {
  var html = '';
  
  if (bcSfFilterConfig.custom.collection_tile_image) {
    html = bcSfFilterTemplate.productTiteItemHtml;
    
    //Image
    var image = bcSfFilterConfig.custom.collection_tile_image;
    html = html.replace(/{{itemThumbUrl}}/g, bcsffilter.optimizeImage(image));
    
    //Heading
    var heading = bcSfFilterConfig.custom.collection_tile_heading;
    html = html.replace(/{{itemTitle}}/g, heading);
    
    //Description
    var description = bcSfFilterConfig.custom.collection_tile_description;
    html = html.replace(/{{itemDescription}}/g, description);
    
    //Video
    var video = bcSfFilterConfig.custom.collection_tile_video;
    html = html.replace(/{{itemVideo}}/g, video);
  }
  
  return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ('ul.pagination').html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    paginationHtml = jQ.parseHTML(paginationHtml);
    jQ('ul.pagination').html(paginationHtml);
  }
};

//modify default pagination click event to scroll to top of page
BCSfFilter.prototype.buildDefaultPaginationEvent = function (a) {
  var b = this,
      c = this.getSelector("pagination");
  parseInt(this.queryParams.page);
  jQ(c).find("a").unbind("click"),
      jQ(c)
          .find("a")
          .on("click", function (a) {
              a.preventDefault(), (b.internalClick = !0);
              var c = jQ(this).attr("href");

              //scroll to top of page
              b.onChangeData(c, "page"), jQ("body,html").animate({ scrollTop: 0 }, 600);
          });
}

// BCSfFilter.prototype.buildPagination = function(totalProduct) {
//   // Get page info
//   var currentPage = parseInt(this.queryParams.page);
//   var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

//   // If it has only one page, clear Pagination
//   if (totalPage == 1) {
//     jQ('ul.pagination').html('');
//     return false;
//   }

//   if (this.getSettingValue('general.paginationType') == 'default') {
//     var paginationHtml = bcSfFilterTemplate.paginateHtml;

//     // Build Previous
//     var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
//     previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
//     paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

//     // Build Next
//     var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
//     nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
//     paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

//     // Build page items
//     paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);

//     jQ('ul.pagination').html(paginationHtml);
//   }

//   jQ('#bc-sf-filter-total-product').html(totalProduct + ' products');
// };

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>View As </span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
  }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /* start-initialize-bc-al */
  var self = this;
  var alEnable = true;
//   var images = data.images_info
//   data = this.prepareProductData(data);
//   console.log(data);
//   var firstVariant = data.variants[0];
  if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
    alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
  }
  if (alEnable === true && typeof BCActionList !== 'undefined') {
    if (typeof bcActionList === 'undefined') {
      bcActionList = new BCActionList();
    } else {
      if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
        bcActionList.initFlag = false;
        bcActionList.alInit(bcSfFilterParams, bcAlParams);
      } else {
        bcActionList.alInit();
      }
    }
    // Swym Wishlist product data code
    //var itemWishlistHtml = '<style>.swym-button.swym-add-to-wishlist-view-product:not(.swym-loaded){display: none;}</style>';
//     var itemWishlistHtml = '<script class="swym-product-view-snippet">';
//     itemWishlistHtml += 'if(!window.SwymViewProducts){'
//     itemWishlistHtml += 'window.SwymViewProducts = {};'
//     itemWishlistHtml += '}';
//     itemWishlistHtml += 'if(!window.SwymWatchProducts){';
//     itemWishlistHtml += 'window.SwymWatchProducts = {};';
//     itemWishlistHtml += '}';
//     itemWishlistHtml += '(function(et){';
//     itemWishlistHtml += 'var collections = ' + JSON.stringify(data.collections[0].title) + ';';
//     itemWishlistHtml += 'var variants = [], currentVariant, variantPrice = ' + (data.price_min / 100) + ', stk;';
//     itemWishlistHtml += 'if (variants.length == 0){';
//     itemWishlistHtml += 'currentVariant = ' + JSON.stringify(firstVariant.id) + ';variants.push({ ' + JSON.stringify(firstVariant.title) + ' :' + JSON.stringify(firstVariant.id) + '});variantPrice = ' + (firstVariant.price / 100) + ';';

//     itemWishlistHtml += 'stk = ' + firstVariant.inventory_quantity + ';';
//     itemWishlistHtml += '}';
//     itemWishlistHtml += 'var product_data = {';
//     itemWishlistHtml += 'empi:' + JSON.stringify(data.id) + ',epi : currentVariant,';
//     itemWishlistHtml += 'dt :' + JSON.stringify(data.title) + ',du  :"' + bcSfFilterConfig.shop.url + '{{itemUrl}}",';
//     itemWishlistHtml += 'ct     :collections,pr     : variantPrice, stk: stk,';
//     itemWishlistHtml += 'iu :' + JSON.stringify(this.getFeaturedImage(images)) + ',variants:variants';
//     itemWishlistHtml += '};';
//     itemWishlistHtml += 'SwymViewProducts[' + JSON.stringify(data.handle) + '] = SwymViewProducts[' + JSON.stringify(data.id) + '] = product_data;';
//     itemWishlistHtml += 'var o = {};';

//     for (var k in data.variants) {
//         var variant = data['variants'][k]
//         itemWishlistHtml += 'o[' + JSON.stringify(variant.id) + '] = {"id": ' + JSON.stringify(variant.id) + ',"inventory_management": ' + JSON.stringify(variant.inventory_management) + ',"inventory_quantity": ' + JSON.stringify(variant.inventory_quantity) + ',"title": ' + JSON.stringify(variant.title) + ', "inventory_policy": ' + JSON.stringify(variant.inventory_policy) + '};';
//     }

//     itemWishlistHtml += 'SwymWatchProducts[' + JSON.stringify(data.handle) + '] = SwymWatchProducts[' + JSON.stringify(data.id) + '] = o;';
//     itemWishlistHtml += '})();';
//     itemWishlistHtml += '</script>';
//     itemWishlistHtml += '<button class="swym-button swym-add-to-wishlist-view-product product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id)  +'"></button>';
    
//     bcActionList.template.atcTemplate = bcActionList.template.atcTemplate.replace(/{{wishlistButton}}/g, itemWishlistHtml);
   /* itemWishlistHtml = '<div class="icon-category">'+
      '<div data-wlh-id="\{\{wlh-id\}\}" '+
' data-wlh-link="\{\{wlh-url\}\}"'+
' data-wlh-variantid="\{\{atcCurrentVariantId\}\}" '+
' data-wlh-price="\{\{wlh-price\}\}" '+
' data-wlh-name="\{\{wlh-name\}\}"'+
' data-wlh-image="\{\{wlh-image\}\}"'+ 
' class="wishlist-hero-custom-button wishlist-hero-floating wishlist-hero-bc-button" '+
' data-wlh-mode="icon_only"'+
' data-wlh-view="Collection"'
'style="left: auto;"></div> '+
      '</div>';
      bcActionList.template.atcTemplate = bcActionList.template.atcTemplate.replace(/{{wishlistButton}}/g, itemWishlistHtml);*/
  }
  /* end-initialize-bc-al */
  jQ('#bc-sf-filter-products').removeClass();
  if (this.queryParams.display == 'list') {
    jQ('#bc-sf-filter-products').addClass('list-view-items');
  } else {
    jQ('#bc-sf-filter-products').addClass('grid grid--uniform grid--view-items');
  }
  if(window._swat){

    window._swat.initializeActionButtons("#bc-sf-filter-products");

  }else{

    window.SwymCallbacks = window.SwymCallbacks || [];


    window.SwymCallbacks.push(function(){

      window._swat.initializeActionButtons("#bc-sf-filter-products");

    });

  }
  
  if (window.SPR) {
    window.SPR.initDomEls();
    window.SPR.loadBadges();
  }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var totalProduct = '';
  if (data.total_product == 1) {
    totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
  } else {
    totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  
  if(window._swat){

    window._swat.initializeActionButtons("#bc-sf-filter-products");

  }else{

    window.SwymCallbacks = window.SwymCallbacks || [];


    window.SwymCallbacks.push(function(){

      window._swat.initializeActionButtons("#bc-sf-filter-products");

    });

  }


  jQ('.info .heading').on('click', function(e){
    e.preventDefault();
    jQ(this).parent('.info').toggleClass('full-detail');
  });

  jQ('.background-image.grid-view-item ').on('mouseenter', function(e){
    e.preventDefault();
    jQ(this).find('.info').addClass('full-detail');
  });

  jQ('.background-image.grid-view-item ').on('mouseleave', function(e){
    e.preventDefault();
    jQ(this).find('.info').removeClass('full-detail');
  });
  
  jQ('.video').off('click').on('click', function(e){
    e.preventDefault();
    //jQ('body').addClass('show-bc-video');
    var url = jQ(this).attr('data-href');
    window.open(url, '_blank').focus();
  });
  
  jQ('.bc-video-popup-icon-close, .bc-video-overlay').off('click').on('click', function(e){
    e.preventDefault();
    jQ('body').removeClass('show-bc-video');
    $('.bc-video-player')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  });
  
//   jQ('body').on('click', self.selector.qvBtnSelector, function(e) {
//       e.preventDefault();
//       if (jQ(self.selector.qvPopupSelector).length == 0) {
//         jQ('<div class="' + self.class.alModalIconLoadingClass + '" style="display:none"></div><div class="' + self.class.alModalWrapperClass + '" id="bc-quickview-popup-wrapper"></div>').appendTo("body");
//       } else {
//         jQ(self.selector.qvPopupSelector).removeClass(self.class.qvPopupActiveClass).empty();
//       }
//       var quickUrl = jQ(this).data('bc-qv-template');
//       var ajaxParams = {
//         url: quickUrl,
//         async: true,
//         beforeSend: function() {
//           // Handle the beforeSend event
//           var alLoading = jQ('.' + self.class.alModalIconLoadingClass);
//           alLoading.css('display', 'block');
//         },
//         success: function(result) {
//           var qvPopup = jQ(self.selector.qvPopupSelector);
//           qvPopup.html(result);
//           self.qvBuildBeforeShowPopupEvents();
//         },
//         complete: function() {
//           var qvPopup = jQ(self.selector.qvPopupSelector);
//           qvPopup.addClass(self.class.qvPopupActiveClass + ' ' + self.class.alModalActiveClass);
//           var alLoading = jQ('.' + self.class.alModalIconLoadingClass);
//           alLoading.css('display', 'none');
//           setTimeout(function() {
//             self.qvBuildComponentEvents();
//             self.qvBuildAfterShowPopupEvents();
//           }, 300);
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//           // Handle the complete event
//           // console.log('qvBuildEvents error: ' + errorThrown)
//         }
//       };
//       jQ.ajax(ajaxParams);
//     });
}


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

/* Mobile Overlay */
BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
  var _this = this;
  var filterSelector = this.getSelector('filterTree');
  var mobileBtnSelector = this.getSelector('filterTreeMobileButton');
  var numOfSelectorsMobile = $('.bc-custom-filter-sidebar-wrapper .bc-sf-filter-selected-items .selected-item').length;

  //change text for mobile filter button 
  if(numOfSelectorsMobile > 0){
    jQ(mobileBtnSelector).text('Filter (' + numOfSelectorsMobile + ')');
  }
  else{
    jQ(mobileBtnSelector).text('Filter');
  }

  // jQ('.bc-custom-filter-sidebar-wrapper .bc-sf-filter-block-content').css('display','block');

  jQ(mobileBtnSelector).unbind('click');
  jQ(mobileBtnSelector).on('click', function() {
      
      jQ('body').toggleClass('bc-custom-drawer-open');
      var style = _this.mobileStyle;
      // Full Width style
      if (style == 'style2' || style == 'style3') {
          jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
          // Build mobile content
          _this.buildFilterTreeMobile();
          // Remove scrollbar
          _this.removeScrollbar(jQ('.' + _this.class.filterBlockContent));
      }
      // Default style
      else {
          // Change button text when clicking
          if (_this.getSettingValue('general.changeMobileButtonLabel')) {
              var openClass = _this.class.mobileButtonOpen;
              jQ(this).toggleClass(openClass);
              var label = jQ(this).hasClass(openClass) ? _this.getSettingValue('label.refineMobileCollapse') : _this.getSettingValue('label.refineMobile');
              jQ(this).text(label);
          }
          jQ(filterSelector).slideToggle(function () {
              jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
              _this.buildFilterOptionBoxStyle(jQ(this));                
              // Re-initialize jscrollpane
              _this.buildFilterScrollbar();
          });
      }
  });

  jQ('.bc-custom-drawer-overlay, .bc-custom-drawer-close').unbind('click');
  jQ('.bc-custom-drawer-overlay, .bc-custom-drawer-close').on('click', function() {
    jQ('body').toggleClass('bc-custom-drawer-open');
    jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
  });
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
